module.exports = "{% if(link){ %} <a href=# class=\"page-num page-tray {%- (currentPage + 1 == pageNumber) ? 'active-page' : '' %}\" data-page-num=\"{%- pageNumber - 1 %}\">{%- pageNumber %}</a> {% } else { %} <i class=\"extra-space page-tray\">...</i> {% } %}";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagableComponent/html/pageTray.html
// module id = 1164
// module chunks = 1